import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { Subscription } from 'rxjs';
import { Desk } from 'src/app/models/turns-models/desk.model';

@Component({
  selector: 'app-turns-new-form-creation-card',
  templateUrl: './turns-new-form-creation-card.component.html',
  styleUrls: ['./turns-new-form-creation-card.component.scss']
})
export class TurnsNewFormCreationCardComponent implements OnInit, OnDestroy {

  centerList;
  sessionContextList;
  selectedDesks;
  desks;
  showButton: boolean;
  addNewFormSubscription: Subscription;
  getFormDesksSubscription: Subscription;
  addNewFormScheduleSubscription: Subscription;
  getFormSessionContextsSubscription: Subscription;
  showSelectContext: boolean;
  basicDataForm = new FormGroup({
    name: new FormControl(null, Validators.required),
    active: new FormControl(true),
    selectedCenter: new FormControl(null, Validators.required),
    selectedSessionContext: new FormControl(null, Validators.required),
    addName: new FormControl(false),
    addSurname: new FormControl(false),
    addDNI: new FormControl(false),
    addMail: new FormControl(false, Validators.email),
    addTelephone: new FormControl(false),
    addLicensePlate: new FormControl(false),
    addPassport: new FormControl(false),
    addDocument: new FormControl(false),
    addCard: new FormControl(false),
    intervalCapacity: new FormControl(null),
    intervalDuration: new FormControl(null),
    maxReservation: new FormControl(null),
    intervalOccupacityAlert: new FormControl(null),
    reservationForDay: new FormControl(false),
    showIntervalFormat: new FormControl(false)
  });

  constructor(private userStorageService: UserStorageService,
              private router: Router,
              private formsTurnsService: FormsTurnsService,
              private spinnerService: SpinnerService,
              private snackbarService: SnackBarService,
              private activatedRoute: ActivatedRoute) {
                this.showButton = true;
                this.selectedDesks = new Array<Desk>();
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public addNewForm() {
    this.showButton = false;
    this.spinnerService.show('form-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewFormSubscription = this.formsTurnsService.addNewForm(this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.getSelectedCenter(), [], this.selectedDesks, this.basicDataForm.get('addName').value, this.basicDataForm.get('addSurname').value, this.basicDataForm.get('addDNI').value, this.basicDataForm.get('addMail').value, this.basicDataForm.get('addTelephone').value, this.basicDataForm.get('addLicensePlate').value, this.basicDataForm.get('addPassport').value, this.basicDataForm.get('addDocument').value, this.basicDataForm.get('addCard').value, this.basicDataForm.get('intervalCapacity').value, this.basicDataForm.get('intervalDuration').value, this.basicDataForm.get('maxReservation').value, this.basicDataForm.get('intervalOccupacityAlert').value, this.basicDataForm.get('reservationForDay').value, this.basicDataForm.get('showIntervalFormat').value, this.getSelectedSessionContext()).subscribe(
        (res) => {
          this.showButton = true;
          this.spinnerService.hide('form-new-spinner');
          this.snackbarService.open('forms-page.snackbar messages.add form success', 'success');
          this.router.navigate(['../forms'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('form-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public cancelForm() {
    this.router.navigate(['../forms'], { relativeTo: this.activatedRoute.parent });
  }

  public getFormDesks() {
    this.getFormDesksSubscription = this.formsTurnsService.getFormDesks(this.basicDataForm.get('selectedCenter').value.InternalId).subscribe(
      (res) => {
        this.desks = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public selectedDeskChanged(event) {
    this.getFormSessionContexts();
    this.selectedDesks = [];
    this.getFormDesks();
  }

  private getFormSessionContexts() {
    this.getFormSessionContextsSubscription = this.formsTurnsService.getFormSessionContexts(this.getSelectedCenter()).subscribe(
      (res) => {
        if (res) {
          this.sessionContextList = res;
          this.showSelectContext = true;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public duallistboxOutputEventReceiver(selectedDesks) {
    const aux = new Array();
    for (const d of selectedDesks) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDesks = aux;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name form error';
    } else if (!this.basicDataForm.get('selectedCenter').value) {
      return 'turns-page.snackbar messages.selected center form error';
    } else if (!this.basicDataForm.get('selectedSessionContext').value) {
      return 'turns-page.snackbar messages.selected session context form error';
    } else if (!this.basicDataForm.get('intervalCapacity').value) {
      return 'turns-page.snackbar messages.intervalCapacity form error';
    } else if (!this.basicDataForm.get('intervalDuration').value) {
      return 'turns-page.snackbar messages.intervalDuration form error';
    } else if (!this.basicDataForm.get('maxReservation').value) {
      return 'turns-page.snackbar messages.maxReservation form error';
    } else if (!this.basicDataForm.get('intervalOccupacityAlert').value) {
      return 'turns-page.snackbar messages.intervalOccupacityAlert form error';
    } else if (!this.selectedDesks || !(this.selectedDesks.length > 0)) {
      return 'turns-page.snackbar messages.at least one desk form error';
    } else {
      return true;
    }
  }

  public getSelectedCenter() {
    if (this.centerList && this.centerList.length > 0) {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedSessionContext() {
    if (this.sessionContextList && this.sessionContextList.length > 0) {
      if (this.basicDataForm.get('selectedSessionContext').value) {
        return this.basicDataForm.get('selectedSessionContext').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.addNewFormSubscription) { this.addNewFormSubscription.unsubscribe(); }
    if (this.getFormDesksSubscription) { this.getFormDesksSubscription.unsubscribe(); }
    if (this.getFormSessionContextsSubscription) { this.getFormSessionContextsSubscription.unsubscribe(); }
  }
}
